import { Observable } from "rxjs";
import _ from "lodash";

import { ProductsRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { createFormInstance, createResourceInstance } from "modules/utils/index";

export const OPEN = "orders/NewOrderModal/OPEN";

export const INITIALIZE_VIEW = "orders/NewOrderModal/NewOrderProductModal/INITIALIZE_VIEW";
export const DESTROY_VIEW = "orders/NewOrderModal/NewOrderProductModal/DESTROY_VIEW";
export const LOAD_PRODUCTS = "orders/NewOrderModal/NewOrderProductModal/LOAD_PRODUCTS";
export const FETCH_PRODUCTS = "orders/NewOrderModal/NewOrderProductModal/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_START = "orders/NewOrderModal/NewOrderProductModal/FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "orders/NewOrderModal/NewOrderProductModal/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "orders/NewOrderModal/NewOrderProductModal/FETCH_PRODUCTS_FAILURE";

export const SET_FILTERS = "orders/NewOrderModal/NewOrderProductModal/SET_FILTERS";
export const UPDATE_FILTERED_ITEMS = "orders/NewOrderModal/NewOrderProductModal/UPDATE_FILTERED_ITEMS";

export const stateSelector = (state) => state.orders.NewOrderModal.NewOrderProductModal;

const productsResource = createResourceInstance({
  FETCH: FETCH_PRODUCTS,
  FETCH_START: FETCH_PRODUCTS_START,
  FETCH_SUCCESS: FETCH_PRODUCTS_SUCCESS,
  FETCH_FAILURE: FETCH_PRODUCTS_FAILURE,
  stateSelector,
  stateKey: "products",
  getModel: () => {
    return ProductsRepository.search({
      limit: 100, // TODO: Review this if makes sense
      status: "published",
    });
  },
});

const initialState = {
  products: productsResource.initialState,
  filteredItems: [],
  filters: {
    companyId: null,
    productId: null,
    query: "",
  },
};

const reducers = {
  ...productsResource.reducersMap,

  [SET_FILTERS]: (state, { filters }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  }),

  [UPDATE_FILTERED_ITEMS]: (state) => {
    if (state.products.model == null) return state;

    return {
      ...state,
      filteredItems: _(state.products.model.records || [])
        .sortBy((p) => {
          return [p.company.id === st.authorize.company.id ? 0 : 1, p.company.name];
        })
        .map((p) => p.product_variants.map((pv) => ({ product: p, product_variant: pv })))
        .flatten()
        .filter(({ product: p, product_variant: pv }) => {
          if (state.filters.companyId && p.company.id !== state.filters.companyId) {
            return false;
          }
          if (state.filters.productId && p.id !== state.filters.productId) {
            return false;
          }
          if (state.filters.query) {
            const searchBase = [p.company.name, p.name || "", pv.name || ""].join("∆").toLowerCase();
            if (searchBase.indexOf(state.filters.query.toLowerCase()) === -1) {
              return false;
            }
          }
          return true;
        })
        .value(),
    };
  },
};

const epics = [
  ...productsResource.epics,

  (actions$) =>
    actions$
      .ofType(FETCH_PRODUCTS_SUCCESS)
      .merge(actions$.ofType(SET_FILTERS).debounceTime(100))
      .mapTo({ type: UPDATE_FILTERED_ITEMS }),
];

export const { fetch: fetchProducts } = productsResource.actions;

export function setFilters(filters) {
  return { type: SET_FILTERS, filters };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderProductModal/index.js